/**
 * Promociones de vitrina (POST /promotions). Ocultas hasta que el API en dev/prod esté listo.
 * Tier pricing (pricing-tiers) sigue disponible cuando esto es false.
 */
import { routes } from '../constants.js/misc';

export const STOREFRONT_PROMOTIONS_ENABLED = false;

export const PROMOTIONS_TAB_QUANTITY = 'quantity';
export const PROMOTIONS_TAB_CART_SUBTOTAL = 'cart_subtotal';

/** Cart discount tier — UI copy (pestaña "Por monto/valor" vs "Por cantidad"). */
export const CART_SUBTOTAL_TAB_LABEL = 'Por monto/valor';
export const CART_SUBTOTAL_TYPE_LABEL = 'Por total';
export const CART_SUBTOTAL_FEATURE_TITLE = 'Descuento por total del carrito';
export const CART_SUBTOTAL_FEATURE_NAME = 'descuento por total del carrito';
export const CART_SUBTOTAL_PAGE_SUBTITLE =
    'Descuentos automáticos según el valor total del carrito.';
export const CART_SUBTOTAL_CREATE_DISABLED_HINT =
    'Solo puedes tener una regla por total del carrito. Edita o elimina la regla actual para crear otra.';

/** Best-of: quantity tier vs cart subtotal tier (never stacked). */
export const PROMOTIONS_BEST_OF_NOTICE =
    'Por cantidad y por total no se suman: en cada producto del carrito se aplica automáticamente el mejor descuento para tu cliente.';

export const parsePromotionsTabFromSearch = (search = '') => {
    const tab = new URLSearchParams(search).get('tab');
    if (tab === PROMOTIONS_TAB_CART_SUBTOTAL) return PROMOTIONS_TAB_CART_SUBTOTAL;
    return PROMOTIONS_TAB_QUANTITY;
};

export const promotionsPageUrl = (tab = PROMOTIONS_TAB_QUANTITY) =>
    tab === PROMOTIONS_TAB_CART_SUBTOTAL
        ? `${routes.promotionsPage}?tab=${PROMOTIONS_TAB_CART_SUBTOTAL}`
        : routes.promotionsPage;

/** Precios Mayoristas — disponible para todas las tiendas en esta rama (sin gate premium). */
export const isPromotionsFeatureEnabled = () => true;

/** Plan gate for Cupones. */
export const isCouponsFeatureEnabled = (storeData) =>
    storeData?.plan_features?.is_coupons_enabled === true;

export const PRICE_STRATEGIES = [
    {
        id: 'current_price',
        label: 'Solo bajar precio de venta',
        shortHint: 'Descuento directo, sin precio tachado',
        summary:
            'Reduce el precio que paga el cliente. No se crea ni modifica un precio tachado en la vitrina.',
    },
    {
        id: 'price_swap',
        label: 'Oferta con precio tachado',
        shortHint: 'Muestra el precio anterior rayado',
        summary:
            'El precio de venta actual pasa a mostrarse tachado y el nuevo precio de venta es el precio con descuento.',
    },
];

/** Estrategias antiguas (solo lectura en listados / promos ya guardadas). */
export const LEGACY_PRICE_STRATEGY_LABELS = {
    compare_at_price: 'Desde precio tachado (obsoleta)',
    both_prices: 'Descontar ambos (obsoleta)',
};

export const ALLOWED_PRICE_STRATEGIES = PRICE_STRATEGIES.map((s) => s.id);

export const PROMOTION_STATUS_LABELS = {
    pending: 'Pendiente',
    applying: 'Aplicando…',
    applied: 'Aplicada',
    failed: 'Error',
};

export const TARGET_TYPES = [
    { id: 'collection', label: 'Categorías' },
    { id: 'product', label: 'Productos específicos' },
];

export const getStrategyLabel = (id) =>
    PRICE_STRATEGIES.find((s) => s.id === id)?.label ??
    LEGACY_PRICE_STRATEGY_LABELS[id] ??
    id;

export const getStrategySummary = (id) =>
    PRICE_STRATEGIES.find((s) => s.id === id)?.summary ?? '';

export const formatPromotionDiscount = (promotion, currency) => {
    if (!promotion) return '';
    if (promotion.discount_type === 'percentage') {
        return `${promotion.discount_value}%`;
    }
    return currency ? `${promotion.discount_value} ${currency}` : String(promotion.discount_value);
};

export const formatDiscountPreview = (discountType, discountValue, currency) => {
    const value = Number(discountValue);
    if (!Number.isFinite(value) || value <= 0) return '—';
    if (discountType === 'percentage') return `${value}%`;
    return currency ? `${value} ${currency}` : String(value);
};
